export default {
  items: [
    {
      name: 'MDS',
      icon: 'mdi-filmstrip',
      auto: true,
      children: [
        {
          name: 'Прокатчики',
          routeName: 'distributors',
          icon: 'fa-circle-o',
        },
        {
          name: 'Лаборатории',
          routeName: 'laboratories',
          icon: 'fa-circle-o',
        },
        {
          name: 'Фильмы',
          routeName: 'movies',
          icon: 'fa-film',
        },
      ],
    },
  ],
};
